import { TextField } from '@vapor/material'
import { Autocomplete, AutocompleteValue } from '@mui/material'
import React from 'react'

export interface AutocompleteTextFieldProps<T, Multiple extends boolean | undefined> {
  multiple?: Multiple
  getOptionLabel: (option: T) => string
  getOptionKey?: (option: T) => string
  options: T[]
  value?: AutocompleteValue<T, Multiple, false, false>
  onChange?: (value: AutocompleteValue<T, Multiple, false, false>) => void
  error?: boolean
  size?: 'small' | 'medium'
  textFieldLabel?: string
  disabled?: boolean
  onFocus?: () => void
  noOptionsText?: string
  placeholder?: string
  inputRef?: React.Ref<any>
}

function AutocompleteTextField<T, Multiple extends boolean | undefined = undefined>(props: AutocompleteTextFieldProps<T, Multiple>) {
  const { options, getOptionLabel, getOptionKey, onChange, value, size, textFieldLabel, error, disabled, multiple, onFocus, noOptionsText, placeholder, inputRef } = props
  return (
    <Autocomplete //
      onFocus={onFocus}
      multiple={multiple}
      options={options}
      getOptionLabel={getOptionLabel}
      onChange={(event, value) => onChange?.(value)}
      value={value}
      disabled={disabled}
      renderInput={(params) => (
        <TextField //
          {...params}
          size={size}
          label={textFieldLabel}
          error={error}
          placeholder={placeholder}
          inputRef={inputRef}
        />
      )}
      renderOption={(props, option, index) => {
        const key = `listItem-${getOptionKey ? getOptionKey(option) : getOptionLabel(option)}`
        return (
          <li {...props} key={key}>
            {getOptionLabel(option)}
          </li>
        )
      }}
      noOptionsText={noOptionsText}
    />
  )
}

export default AutocompleteTextField
